import {
  MOST_RECENT_HEALTH_DATA,
  UPDATE_HEALTH_DATA,
  GET_PATIENT_MED_HISTORY,
  UPDATE_PATIENT_MED_HISTORY,
} from '../actions/types';
import {
  mapHealthDataTypeNumToVarName,
  mapDiabetesTypeStringToNum,
  mapDRPresenceTypeStringtoNum,
  mapMEPresenceTypeStringtoNum,
} from '../utils/conversions';
import {
  DIABETES_ONSET,
  DIABETES_TYPE,
  DIABETES_TYPE_UNKNOWN,
  DR_PRESENCE,
  MACULAR_EDEMA_PRESENCE,
} from '../constants/medicalRecords';

const initialState = {
  healthDataUpdated: '',
  mostRecentHealthData: {},
  medHistory: {},
  created: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case MOST_RECENT_HEALTH_DATA:
      return {
        ...state,
        mostRecentHealthData: { ...action.payload },
      };
    case UPDATE_HEALTH_DATA:
      return {
        ...state,
        healthDataUpdated: action.payload,
      };
    case GET_PATIENT_MED_HISTORY:
      let newMedHistory = { ...action.payload };
      for (const key of Object.keys(newMedHistory)) {
        // receives string from backend, hence need to convert to its constant value
        // but backend doesnt provide string for unknown (empty) diabetes type, it provides the UNKNOWN key
        if (newMedHistory[key].values === '-') newMedHistory[key].values = null;
        else if (parseInt(key) === DIABETES_ONSET && newMedHistory[key].values !== null) {
          newMedHistory[key].values = new Date(newMedHistory[key].values);
        }
        // change the key name (from number to variable name)
        delete Object.assign(newMedHistory, { [mapHealthDataTypeNumToVarName(key)]: newMedHistory[key] })[key];
      }

      return {
        ...state,
        medHistory: { ...newMedHistory },
      };
    case UPDATE_PATIENT_MED_HISTORY:
      return {
        ...state,
        created: action.payload,
      };
    default:
      return state;
  }
}
